/*
 * @Author: liyihui
 * @Date:
 * @description: 请求处理，油商接口
 * @Last Modified by:
 * @Last Modified time:
 */
import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
// import store from '../store'; // 未引入store
import { getToken, getUserId, getRefreshToken, getExpiresTime, setRefreshToken, setExpiresTime, removeToken } from '@/utils/auth';
import { closeLoading } from '@/utils/tools';

// 创建axios实例
// const isPro = Object.is(process.env.NODE_ENV, 'production'); // 判断是否为生产环境
// const baseUrl = isPro ? process.env.BASE_API + '/' : '';

const baseUrl = process.env.BASE_API;
const service = axios.create({
	baseURL: baseUrl,
	timeout: 120000,
}); // 请求超时时间

// request拦截器
service.interceptors.request.use(
	config => {
		// 
		if (config.url.indexOf('file/') > 0) {
			config.responseType = 'blob';
		}
		if (getToken()) {
			config.headers['Authorization'] = getToken(); // 让每个请求携带自定义token 请根据实际情况自行修改
		}
		return config;
	},
	error => {
		console.log(error);
		Promise.reject(error);
	},
);

// response 拦截器
service.interceptors.response.use(
	response => {
		if (response.config.params.format || response.config.params.size) {
			return response.data;
		}
		var res = response.data;

		if (res.status === 200 || res.code === 0) { // banner接口用的code
			return res;
		} else if (res.status === 406) {

			MessageBox.alert('您当前为非法登录！', '通知', {
				confirmButtonText: '确定',
				callback: action => {
					location.reload();
				},
			});

			return;
			store.dispatch('FedLogOut').then(() => {
			});
		} else if (res.status === 403) {
			MessageBox.alert('您的登录信息已失效，请重新登录', '通知', {
				confirmButtonText: '确定',
				callback: action => {
					location.reload();
				},
			});
			next({ path: '/' });
			return;
			store.dispatch('FedLogOut').then(() => {
			});
		} else {
			closeLoading();
			Message({
				dangerouslyUseHTMLString: true,
				message: res.status + '<strong>&nbsp;</strong>' + res.description,
				type: 'error',
				duration: 5 * 1000,
			});
			return res;
		}
	},
	error => {
		if (error.response.status === 401 || error.response.status === 403) {
			removeToken();
			MessageBox.confirm('登录已失效', '通知', {
				confirmButtonText: '前往登录',
				cancelButtonText: '确定',
			}).then(() => {
				router.push({ name: 'login'});
			}).catch(() => {
			});
		}
		return Promise.reject(error);
	},
);

/**
 * get方法，对应get请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function BJget(url, params) {
	return new Promise((resolve, reject) => {
		service.get(baseUrl + url, { params: params }).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err);
		});
	});
}
/**
 * post方法，对应post请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function BJpost(url, params) {
	return new Promise((resolve, reject) => {
		service.post(baseUrl + url, params).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err.data);
		});
	});
}
/**
 * put方法，对应put请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function BJput(url, params) {
	return new Promise((resolve, reject) => {
		service.put(baseUrl + url, params).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err.data);
		});
	});
}
/**
 * del方法，对应del请求
 * @param {String} url [请求的url地址]
 * @param {Object} params [请求时携带的参数]
 */
export function BJdel(url, params) {
	return new Promise((resolve, reject) => {
		service.delete(baseUrl + url, params).then(res => {
			resolve(res);
		}).catch(err => {
			reject(err.data);
		});
	});
}



// WEBPACK FOOTER //
// ./src/utils/requestTeamBJ.js